import React from 'react'
import { Folder2Open, Printer } from 'react-bootstrap-icons'
import { permuteDateFromString } from '../../services/Fonctions'
import Export from '../../pdf/Export'

function Tanzanie({ data, declaration }) {
    const textPeriode = (d, f) => {
        if ((d != f) && f != null) {
            return d + " - " + f
        }
        return d
    }

    return (
        <div>
            <div className='d-flex'>
                <button className='btn btn-secondary' onClick={() => { new Export().printTZDeclaration(data) }}><Printer /></button>
                <form target='_blank' method='POST' action={"http://localhost:8000/pieces/" + permuteDateFromString(data[0].debut_periode) + "/" + declaration}>
                    <input type='hidden' />
                    <button className='btn btn-warning'><Folder2Open /></button>
                </form>
            </div>
            <table className='table table-striped table-bordered' style={{ fontSize: '12px' }}>
                <tbody>
                    <DetailsLine title="Période Transmis" value={textPeriode(data[0].debut_periode, data[0].fin_periode)} />
                    <DetailsLine title="Modèle de la déclaration" value={data[0].modele} />
                    <DetailsLine title="Date T1" value={data[0].date_t1} />
                    <DetailsLine title="Importateur" value={data[0].importateur} />
                    <DetailsLine title="Expéditeur" value={data[0].expediteur} />
                    <DetailsLine title="Pays origine/exportation" value={data[0].pays_origine_export} />
                    <DetailsLine title="B/L" value={data[0].bl} />
                    <DetailsLine title="Destination" value={data[0].destination} />
                    <DetailsLine title="Marchandise" value={data[0].nature} />
                    <DetailsLine title="Code HS" value={data[0].code_hs} />
                </tbody>
            </table>

            <h5>Liste des cargaisons : </h5>
            <table className='table table-striped table-bordered' style={{ fontSize: '12px' }}>
                <thead className=''>
                    <tr className='table-primary'>
                        <th>Véhicule</th>
                        <th>Conteneur/Châssis</th>
                        <th>Type cont.</th>
                        <th>Quantite</th>
                        <th>Poids</th>
                        <th>Valeur facture</th>
                        <th>CIF</th>
                    </tr>

                </thead>
                <tbody>
                    {
                        data.map(d => {
                            return (
                                <tr>
                                    <td>{d.vehicule}</td>
                                    <td>{d.conteneurs}{d.chassis && "/" + d.chassis}</td>
                                    <td>{d.type_conteneur}</td>
                                    <td>{d.quantite}</td>
                                    <td>{d.poids}</td>
                                    <td>{d.valeur_facture}</td>
                                    <td>{d.cif}</td>
                                </tr>
                            )
                        })
                    }
                </tbody>
            </table>
        </div>
    )
}

function DetailsLine({ title, value }) {
    return (
        <tr>
            <th>{title}</th>
            <td>{value}</td>
        </tr>
    )
}

export default Tanzanie